/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit No/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import User from './User/index'



/** @type {import('Simple/types.js').View} */
export default function No({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Board/Board/Content/Card/Assignees/Content/SearchResult/No"
  
}) {
let assigneeDefaultsValueData = fromData.useDataValue({ viewPath,
context: 'assignee_defaults',
})
  return (<React.Fragment
>
<div
  data-testid="No.List"
  data-view-path={viewPath}
 className="views-block"
>
{Array.isArray(assigneeDefaultsValueData) && assigneeDefaultsValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="person"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/User(${item?.id ?? item?._id ?? index})`}
      >
<User
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/User(${item?.id ?? item?._id ?? index})`}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }